<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:[`item.status`]="{ item }">
                <tr v-if="item.status == 'active'">
                  <td class="active-class">{{ item.status }}</td>
                </tr>
                <tr v-if="item.status == 'inactive'">
                  <td class="inactive-class">{{ item.status }}</td>
                </tr>
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <div class="col-md-3 col-6">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="compaign-container">
                    <v-btn class="campaign-btn" @click="addCampaign"
                      >Add Compaign</v-btn
                    >
                  </div>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    search: "",
    switch1: true,
    headers: [
      {
        text: "Campaign Type",
        align: "start",
        sortable: false,
        value: "type",
      },
      { text: "Campaign Mode", value: "campaign_mode" },
      { text: "Campaign Topic", value: "topic" },
      { text: "Frequency", value: "frequency" },
      { text: "Start Date", value: "campaign_start_date" },
      { text: "End Date", value: "campaign_end_date" },
       { text: "Campaign Time", value: "campaign_time" },
      { text: "Status", value: "status" },
      { text: "Actions", value: "actions", sortable: false },
      //  { text: "Status", value: "toggels", sortable: false },
    ],
    items: [],
  }),
  created() {
    this.initialize();
  },
  methods: {
    addCampaign() {
      this.$router.push({ name: "AddCampaign" }).catch(() => {});
    },
    initialize() {
      this.items = [];
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_ROOT_API + "admin/campaigns", {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          //  this.items = response.data;
          this.items = response.data;
          console.log("items", response);
        });
    },
    deleteItem(item) {
      console.log(item);
      swal
        .fire({
          title: "Are you sure, you want to delete this data?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then((result) => {
          if (result.isConfirmed) {
            let token = localStorage.getItem("token");
            axios
              .delete(
                process.env.VUE_APP_ROOT_API + "admin/campaigns/" + item.id,
                {
                  headers: {
                    Authorization: "Bearer " + token,
                  },
                }
              )
              .then((response) => {
                this.initialize();
                Toast.fire({
                  icon: "success",
                  title: "Data deleted successfully.",
                });
              });
          }
        });
    },
    editItem(item) {
      this.$router
        .push({ path: "/admin/edit-campaign/" + btoa(item.id) })
        .catch(() => {});
    },
  },
};
</script>
<style>
.compaign-container {
  margin-top: 0px;
  float: left;
}
</style>